import { ScenarioDefinitionModel } from 'src/app/admin/admin-home/admin-credentials/admin-credential-scenario/scenario-definition-model';
import { CredentialDefinitionStatus } from './credential-definition.model';
import { CredentialApplicationAutoCloseRuleModel } from 'src/app/admin/admin-home/admin-credentials/admin-credential-application/admin-credential-application-auto-close-sidebar/credential-application-auto-close-rule.model';
import { AdminSpecialtySettingModel } from 'src/app/admin/admin-home/admin-credentials/admin-credential-application/admin-specialty-settings/admin-specialty-setting.model';
import { CredentialApplicationDefinitionType } from './CredentialApplicationDefinitionType';

export class CredentialApplicationDefinitionModel {
  public id: string;
  public credentialDefinitionId: string;
  public credentialDefinitionName: string;
  public type: CredentialApplicationDefinitionType;
  public status: CredentialDefinitionStatus;
  public scenarios: ScenarioDefinitionModel[] = [];
  public autoCloseRule: CredentialApplicationAutoCloseRuleModel;
  public credentialSpecialtySetting: AdminSpecialtySettingModel;
  public typeText: string;
  constructor(data?: CredentialApplicationDefinitionModel) {
    if (!data) return;
    this.id = data.id;
    this.credentialDefinitionId = data.credentialDefinitionId;
    this.credentialDefinitionName = data.credentialDefinitionName;
    this.type = data.type;
    this.status = data.status;
    this.scenarios = data.scenarios
      ? data.scenarios.map((scenario) => new ScenarioDefinitionModel(scenario))
      : [];
    this.autoCloseRule = data.autoCloseRule;
    this.credentialSpecialtySetting = data.credentialSpecialtySetting;
    this.typeText = this.getTypeText();
  }

  public get activeScenariosCount(): number {
    return this.scenarios.filter((scenario) => scenario.isActive).length;
  }

  private getTypeText(): string {
    if (this.type == CredentialApplicationDefinitionType.Initial) return 'New Credential';
    return this.type;
  }
}
